export default "__VITE_ASSET__Y8xj6ULi__"